import React, {Fragment} from 'react';

const Banner = () => {
    return (
        <Fragment>
            <div className="bannerImg">
                <div className="BannerOverlay">
                   <div className="fullBanner">
                       <div className="BannerText">
                           <h1>Bangla Express Ecommerse</h1>
                           <p>Enjoy Online Shopping with BD express</p>
                       </div>
                   </div>

                </div>
            </div>

        </Fragment>
    );
};

export default Banner;